import { createStore } from 'vuex'
import { auth } from './auth.module'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    showMap: false,
    currentfleet: localStorage.getItem('currentfleet') || '',
    cachedDate: '',
    cachedDateRange: '',
    log: {},
    onlyShowAvailableStreams:
      localStorage.getItem('onlyShowAvailableStreams') === 'true',
    // Which of this user's fleets have Live Map fleet-server config --
    // not persisted, recomputed each session same as availableFleets.
    liveMapConfiguredFleets: [],
  },
  mutations: {
    setLiveMapConfiguredFleets(state, fleetIds) {
      state.liveMapConfiguredFleets = fleetIds
    },
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    setCurrentFleet(state, fleetId) {
      state.currentfleet = fleetId
      localStorage.setItem('currentfleet', fleetId)
    },
    toggleOnlyShowAvailableStreams(state) {
      state.onlyShowAvailableStreams = !state.onlyShowAvailableStreams
      localStorage.setItem(
        'onlyShowAvailableStreams',
        state.onlyShowAvailableStreams,
      )
    },
    setOnlyShowAvailableStreams(state, value) {
      state.onlyShowAvailableStreams = !!value
      localStorage.setItem(
        'onlyShowAvailableStreams',
        state.onlyShowAvailableStreams,
      )
    },
  },
  actions: {},
  modules: {
    auth,
  },
})
